module.exports = __webpack_public_path__ + "img/footer.f1688bea.jpg";